import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["text-white w-6 h-4 my-auto text-center rounded items-center justify-center shadow-lg", `${_ctx.bgColor}`]),
    style: {"padding-bottom":"2px","font-size":"0.75rem"}
  }, _toDisplayString(_ctx.abbr), 3))
}